import { render, staticRenderFns } from "./PodcastTable.vue?vue&type=template&id=10a75c26&scoped=true"
import script from "./PodcastTable.vue?vue&type=script&lang=js"
export * from "./PodcastTable.vue?vue&type=script&lang=js"
import style0 from "./PodcastTable.vue?vue&type=style&index=0&id=10a75c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a75c26",
  null
  
)

export default component.exports